module.exports = __webpack_public_path__ + "img/2104.648efe68.png";